import React from "react";

export default function MapIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6 11.2A.5.5 0 0 1 4 11h2.5a.5.5 0 0 1 0 1H4.25L2 15h13l-2.25-3H10.5a.5.5 0 0 1 0-1H13a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H1a.5.5 0 0 1-.4-.8l3-4Z"
        fill="#3E4957"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-4 3A4 4 0 1 1 9 7.969V13.5a.5.5 0 0 1-1 0V7.97a4 4 0 0 1-3.5-3.97Z"
        fill="#3E4957"
      />
    </svg>
  );
}
